import React from 'react';
import './ExploreModels.css';

function ExploreModels() {
  return (
    <section className="explore-models">
      <div className="explore-models__inner">
        <h2 className="explore-models__title">Explore Our Models</h2>
        <p className="explore-models__text">
          If you're ready to find a Boston Whaler that's best suited for your boating style, then let's get started!
        </p>
        <a href="/models" className="explore-models__cta">
          Explore Models
        </a>
      </div>
    </section>
  );
}

export default ExploreModels;
